export default {
  message: {
    welcome:'welcome to Huayan Juzhu',
    search: 'search',
    placeHolder:'Please enter keywords to search',
    quantity:'Quantity',
    color: 'color',
    design: 'design',
    specifications: 'specifications',
    China: 'China',
    MinimumOrder: 'Minimum order',
    squareMeter:'square meter',
    thickness:'thickness',
    price:'price',
    material:'material',
    sendEmail:'send email',
    phoneCall:'make a call',
    ProductDetails:'Product Details',
    Ltd:'Xuchang ShiTaocheng Stone Industry Co., Ltd',
    name:'Wang Ningbo',
    Tel:'Tel',
    SalesManager:'Sales Manager',
    ContactTheSupplier:'Contact the supplier',
    languageList:{
      item0:'Chinese',
      item1:'English',
      item2:'Arabic',
      item3:'Vietnamese',
      // item4:'Indonesian'
    },
    desc:'Huayan Juzhu has established a perfect global stone supply chain system, established its own product matrix, and optimized the ecological layout of the upstream and downstream industries through the industrial Internet. Since its establishment in 2020, nearly 20 central stores have covered Henan, Anhui, Shandong, Hunan, Hebei, Tianjin, and Beijing. Its annual sales volume of granite is 3.6 million m3, becoming the largest granite producer and seller in China, with 3 million m3 granite, 500000 m3 quartz, and 200000 m3 rock slab, becoming the leader in the domestic industry. Through the Internet, we constantly optimize the supply chain structure to provide better services, improve the existing retail model, use big data and intelligent software and hardware, and break through the inherent stone wholesale experience.'
  }
}